import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { FormattedMessage } from "react-intl";

const AuthToggle = ({ userType, onChange }) => {
  const isCand = userType === "candidate";

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        borderRadius: "9999px",
        overflow: "hidden",
        border: "1px solid hsl(214.3, 31.8%, 91.4%)",
      }}
    >
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "50%",
          borderRadius: "9999px",
        }}
        animate={{
          x: isCand ? 0 : "100%",
          backgroundColor: "hsl(153, 68%, 25%)",
        }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      />
      <Box
        component="button"
        type="button"
        onClick={() => onChange("candidate")}
        sx={{
          position: "relative",
          zIndex: 10,
          flex: 1,
          px: "2rem",
          py: "0.75rem",
          fontSize: "0.875rem",
          fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          transition: "color 0.3s",
          cursor: "pointer",
          border: "none",
          bgcolor: "transparent",
          color: isCand ? "hsl(0, 0%, 100%)" : "hsl(215.4, 16.3%, 46.9%)",
          "&:hover": {
            color: isCand ? "hsl(0, 0%, 100%)" : "hsl(222.2, 84%, 4.9%)",
          },
        }}
      >
        <FormattedMessage id="candidate.candidate" />
      </Box>
      <Box
        component="button"
        type="button"
        onClick={() => onChange("recruiter")}
        sx={{
          position: "relative",
          zIndex: 10,
          flex: 1,
          px: "2rem",
          py: "0.75rem",
          fontSize: "0.875rem",
          fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          transition: "color 0.3s",
          cursor: "pointer",
          border: "none",
          bgcolor: "transparent",
          color: !isCand ? "hsl(0, 0%, 100%)" : "hsl(215.4, 16.3%, 46.9%)",
          "&:hover": {
            color: !isCand ? "hsl(0, 0%, 100%)" : "hsl(222.2, 84%, 4.9%)",
          },
        }}
      >
        <FormattedMessage id="recruiter.recruiter" />
      </Box>
    </Box>
  );
};

export default AuthToggle;
